import { loggedIn, itemsInBasket } from '../../../routes/conditional';
import { removeOrderItem } from '../../../redux/modules/neworder';
import paths from '../../../routes/paths';
import { getNewOrderItems } from '../../../redux/modules/root-reducer';
import { basketFlowStarted } from '../../../redux/modules/orders';

export const page = {
  path: paths.createOrder.basket,
  isAllowed: [loggedIn, itemsInBasket],
  action: () => basketFlowStarted(),
};

const ACTION_PATH = '/actions/remove-medicine';

export const removeMedicine = {
  actionPath: ACTION_PATH,
  action: ({ query, state }) => {
    const idx = parseInt(query.index);
    const isLastItem = getNewOrderItems(state).length === 1;
    return removeOrderItem(idx, isLastItem);
  },
  buildFormActionPath: (i) => `${ACTION_PATH}?index=${i}`,
};
